
import store from "../../../../infrastructure/repository/store/store";
import { defineComponent, onMounted, watch } from "vue";

class Error {
  public message: string;
  public changed: boolean;

  constructor(message = "", changed = false) {
    this.message = message;
    this.changed = changed;
  }
}

export default defineComponent({
  props: {
    error: {
      type: Object,
      required: true
    }
  },

  /**
   * note: wouldn't it make more sense to approach this with class binding? it'd probably be less verbose
   * +todo: document the whole thing
   */
  setup(props) {
    onMounted(() => {
      const box = document.querySelector("[data-box]") as HTMLDivElement;
      box.addEventListener("animationend", () => {
        if (box.classList.contains("open")) {
          box.classList.remove("open");
          box.classList.add("close");
          store.dispatch("miscellany_module/setError", {
            message: props.error.message,
            changed: false
          });
        }
      });
    });

    watch(
      () => props.error.changed,
      () => {
        if (props.error.changed) {
          const box = document.querySelector("[data-box]") as HTMLDivElement;
          box.classList.add("open");
        }
      }
    );
  }
});
